<rt-box layout-vertical variant="no-padding background">
  @for (item of flattenedPlacements; track offerAndLocationTrackBy(item); let i = $index) {
    @if (i !== 0) {
      <rt-divider />
    }
    <rt-radio
      [checked]="offerAndLocationSelected(item.offer, item.location)"
      [hasNoTBMargin]="true"
      [hasAlignItemsStart]="true"
      (click)="offerAndLocationClicked(item.offer, item.location)"
      variant="check"
      padding-medium
    >
      <div layout-horizontal class="radio-label-container">
        <div class="offer-status-indicator-container" layout-vertical>
          <rt-offer-status-indicator [offerStatus]="item.offer" />
        </div>
        <div layout-vertical>
          <rt-heading>{{ item.offer.title }}</rt-heading>
          <div>{{ locationLabel(item.location) }}</div>
        </div>
      </div>
    </rt-radio>
  }
</rt-box>
